import { ExTable, NestedModal, TableBody, TableHead } from 'components/shared/widget'
import { Button, Modal, Table } from 'react-bootstrap'
import { Probe } from 'entities/probe'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { probeColumnInfoList, ProbeTableData } from 'components/probe/probe_table'
import { probeStockColumnInfoList, ProbeStockTableData } from 'components/probe_stock/probe_stock_table'
import { ProbeStock } from 'entities/probe_stock'

type SelectProbeModalProps = {
    show: boolean
    onClose: () => void
    title: string
    probes: Probe[]
}

const ProbesModal = (props: SelectProbeModalProps) => {
    const probeDisplaySetting = useDisplaySetting(probeColumnInfoList(), 'SelectProbe', 'default_visible')
    return (
        <>
            <Modal show={props.show} onHide={props.onClose} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: 0 }}>
                    <div style={{ height: '75vh', overflow: 'scroll' }}>
                        <ExTable className="sticky-table">
                            <TableHead>
                                <tr>
                                    <TableHeads displaySetting={probeDisplaySetting} />
                                </tr>
                            </TableHead>
                            <TableBody>
                                {props.probes.map((probe: Probe) => {
                                    return (
                                        <tr key={`clinical-${probe.id}`}>
                                            <ProbeTableData probe={probe} displaySetting={probeDisplaySetting} />
                                        </tr>
                                    )
                                })}
                            </TableBody>
                        </ExTable>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={props.onClose}>
                        閉じる
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

type ProbeStockModalProps = {
    show: boolean
    onClose: () => void
    probe: Probe
}

export const ProbeStockModal = (props: ProbeStockModalProps) => {
    const probeStockDisplaySetting = useDisplaySetting(probeStockColumnInfoList(), 'ProbeStock')

    return (
        <NestedModal show={props.show} onHide={() => props.onClose()} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>{props.probe.name} 在庫</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ overflow: 'scroll' }}>
                    <Table>
                        <TableHead>
                            <tr>
                                <TableHeads displaySetting={probeStockDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody>
                            {props.probe.probeStocks?.map((probeStock: ProbeStock) => {
                                return (
                                    <tr key={probeStock.id}>
                                        <ProbeStockTableData probeStock={probeStock} displaySetting={probeStockDisplaySetting} />
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={() => {
                        props.onClose()
                    }}
                >
                    閉じる
                </Button>
            </Modal.Footer>
        </NestedModal>
    )
}

export default ProbesModal
